<div class='header' [ngClass]="{'header-thank-you' : !formService.formActive}">
	<div class='container'>
		<div class='content'>
			<div class="leftside">
				<div class='mobile-leo' *ngIf='!formService.isAffiliateMode && !formService.disableSirLeo'>
					<a [href]='getHomeUrl()'>
						<mat-icon svgIcon='icons:sir-leo-headshot'></mat-icon>
					</a>
				</div>
				<div class='logo' *ngIf='!formService.isAffiliateMode'>
					<a [href]='getHomeUrl()'>
						<mat-icon svgIcon='images:logo'></mat-icon>
					</a>
				</div>
			</div>
			<div class='progress-section' *ngIf='formService.formActive'>
				<div class='progress-header'>
					<div class='title' i18n>Your Quote Request</div>
					<div class='percentage' i18n>{{formService.progress}}% <span>progress</span></div>
				</div>
				<div class='bar'>
					<div [style.width.%]='formService.progress' class='point-of-progress'></div>
				</div>
			</div>
		</div>
	</div>
</div>